import {displayPublicationListingFn} from './functions/publications_display';
import filterHandle, {rangeHandle} from './functions/filters';

window.addEventListener('DOMContentLoaded', () => {
  displayPublicationListingFn();
  filterHandle();
  rangeHandle();
})
